import './App.css';

function App() {
  return (
    <div className="app">
      {/* Section 1: Happy Birthday */}
      <section className="section">
        <h1 className="title">Happy Birthday, Hritik!</h1>
        <p className="subtitle">A celebration fit for the Seven Kingdoms</p>
        <img 
          src="https://media.giphy.com/media/v1.Y2lkPWVjZjA1ZTQ3bTlieng1NWZ5NGh2Njd4YjRpZTVvOWptdGc1b2MzZXBubjltcG84cyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/KfCL9Gp4WSFzO/giphy.gif"
          alt="Game of Thrones Birthday"
          className="gif"
        />
      </section>

      {/* Section 2: Battle Ready */}
      <section className="section">
        <h2 className="heading">Battles Await — Stand Tall</h2>
        <p className="quote">"May your courage be loud, your doubts be silent, and your victories many.."</p>
        <img 
          src="https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExbGxkYmZoYm4yZjI4b25oZXZ5bHcxMWphNDUxNGNhOWl0aHZwcHVlbiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3oEjI1erPMTMBFmNHi/giphy.gif"
          alt="Battle Ready"
          className="gif"
        />
      </section>

      {/* Section 3: True Friend */}
      <section className="section">
        <h2 className="heading">A Friend Worthy of the Seven Kingdoms</h2>
        <p className="quote">
          "When the winds howled and shadows gathered, you were the one who did not flee.
          For that, I name you a true friend of my house."
        </p>
        <img 
          src="https://media.giphy.com/media/v1.Y2lkPWVjZjA1ZTQ3eGh5bzR0ZDlweDBwY29hMXI0aWhvbGh6Z2FuOHF3YzB5ZHUyaGtwZiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/UJ5FV7pqdiuQM/giphy.gif"
          alt="A Friend Worthy of the Seven Kingdoms"
          className="gif"
        />
      </section>

      {/* Section 4: Tyrion Gift */}
      <section className="section">
        <h2 className="heading">I hope you get more friends like me this year...</h2>
        <p className="quote">"Because I drink and I know things" 🍷</p>
        <img 
          src="https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExNDFuMWRjeXcwYzl2anlraGt4N3hrOXlrbndsc3poZDRncWJmMThtdSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/lz0fR8nwQfbq/giphy.gif"
          alt="Tyrion - I am a gift"
          className="gif"
        />
        <p className="gift-text">I am the gift. 🎁</p>
      </section>

      
    </div>
  );
}

export default App;
